import { initPage } from './initPage'
import { bootstrap as initPre } from './pre'

$(() => {
    initPage()

    initPre()
})
